import { makeRunnerBroker, type BrokerWorker } from "./broker-core";
import { runnerProtocol, type BrokerResponse } from "./protocol";

const allowedOrigins = new Set([
  "https://lucasbarake.com",
  "http://localhost:5173",
  "http://127.0.0.1:5173",
]);

const broker = makeRunnerBroker({
  parent: window.parent,
  allowedOrigins,
  createWorker: () =>
    new Worker(new URL("./execution-worker.ts", import.meta.url), {
      type: "module",
      name: "effect-atom-run",
    }) as BrokerWorker,
});

window.addEventListener("message", broker.handleMessage);
window.addEventListener("pagehide", broker.dispose, { once: true });

// The iframe is only mounted once the learner has an interactive problem open, so the module
// instantiation of the execution Worker can start now instead of on the Run click.
broker.prewarm();

// Announce once per allowlisted origin rather than broadcasting. The browser drops any message
// whose targetOrigin does not match the real parent, so exactly one announcement is delivered and
// origin confidentiality does not depend on the `frame-ancestors` header alone -- which `vite
// preview`, used by the e2e run, does not serve at all.
for (const origin of allowedOrigins) {
  window.parent.postMessage(
    {
      protocol: runnerProtocol,
      kind: "ready",
    } satisfies BrokerResponse,
    origin,
  );
}
